import { useEditPageContext } from 'components/shared/CRUD/components/InnerPage/EditPageContext';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useFieldArray } from 'react-hook-form';
import { findIndexFromFieldsArray } from 'components/shared/CRUD/utils/utils';
import useRemoveUncommitted from 'components/shared/CRUD/components/InnerPage/hooks/useRemoveUncommitted';
import { fieldArrayContext } from 'components/shared/CRUD/components/InnerPage/hooks/useFieldArrayContext';
import TableCRUDLayout from 'components/shared/CRUD/TableCRUDLayout';
import withFieldArrayDrawer from 'components/shared/CRUD/components/InnerPage/components/withFieldArrayDrawer';
import { AccountGroupSection } from './AccountGroupSection';
import { useGetAccountGroupsColumns } from './hooks/useGetAccountGroupsColumns';

const EditAccountGroups = withFieldArrayDrawer(AccountGroupSection, 'groups');
export const AccountGroupsTable = () => {
  const { t } = useTranslation('common');
  const { isEditable } = useEditPageContext();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const accountGroupsColumns = useGetAccountGroupsColumns();

  const {
    fields: groups,
    append,
    remove,
    update,
    replace
  } = useFieldArray({
    name: 'groups'
  });

  const onAddNew = () => {
    // add a new empty record to the fieldArray
    append({ name: '', valid: { from: null, to: null } });
    setIsDrawerOpen(true);
  };

  const onDelete = (fieldIds) => {
    remove(findIndexFromFieldsArray(fieldIds[0], groups));
  };

  useRemoveUncommitted(groups, isDrawerOpen, remove);

  const onCloseInnerView = () => {
    setIsDrawerOpen(false);
  };

  return (
    <fieldArrayContext.Provider
      value={{ fields: groups, append, remove, update, replace }}
    >
      <TableCRUDLayout
        columns={accountGroupsColumns}
        rows={groups}
        FormComponent={EditAccountGroups}
        getRowId={(travelLine) => travelLine.id}
        dynamicHeight={true}
        disableActions={!isEditable}
        onAddClick={onAddNew}
        onDeleteClick={onDelete}
        confirmationTitle={t('deleteDialog.confirmationTitle')}
        confirmationBody={t('deleteDialog.confirmationBody')}
        onClose={onCloseInnerView}
        shouldRenderToolBar={false}
      />
    </fieldArrayContext.Provider>
  );
};
